import { makeStyles } from '@mui/styles';
import Modal from 'apollo-react/components/Modal';
import Tab from 'apollo-react/components/Tab';
import Tabs from 'apollo-react/components/Tabs';
import React, { useEffect, useState } from 'react';

import CustomTable from './CustomTable';
import { useFormSelector } from '../../custom-hooks';
import { useTranslation } from '../../custom-hooks/useTranslation';
import { getCustomFormsAndWorkflows } from '../../selectors/UpgradeModulesSelectors';

const useStyles = makeStyles({
  modal: {
    minWidth: '65%',
  },
});

const CustomComponentsModal = ({ open, setOpen, moduleId }) => {
  const { CustomForms: customForms, CustomWorkflows: customWorkflows } = useFormSelector(
    getCustomFormsAndWorkflows,
    {
      moduleId,
    }
  );
  const translateString = useTranslation();

  const tabContent = [
    <CustomTable
      key={0}
      title={translateString('Custom Forms')}
      rows={customForms || []}
    ></CustomTable>,
    <CustomTable
      key={1}
      title={translateString('Custom Workflows')}
      rows={customWorkflows || []}
    ></CustomTable>,
  ];
  const classes = useStyles();
  const [currentTab, setCurrentTab] = useState(0);

  const handleTabChange = (_, tabValue) => {
    setCurrentTab(tabValue);
  };

  useEffect(() => {
    if (open) {
      setCurrentTab(0);
    }
  }, [open]);

  return (
    <Modal
      className={classes.modal}
      open={open}
      variant="default"
      onClose={() => setOpen(false)}
      title={translateString('Custom Components')}
      hideButtons
      disableEscapeKeyDown
      disableBackdropClick
    >
      <Tabs value={currentTab} onChange={handleTabChange}>
        <Tab label={translateString('Custom Forms')} />
        <Tab label={translateString('Custom Workflows')} />
      </Tabs>
      {tabContent[currentTab]}
    </Modal>
  );
};

export default CustomComponentsModal;
